const article = {
  id: 5,
  category: "Fiscalité 2026",
  title: "Loi de finances 2026 : 5 mesures qui vont impacter votre fiscalité",
  text: "Gel du barème de l’impôt, suppression de l’abattement retraite, nouvelles taxes… Nos experts analysent les changements et vous proposent des solutions d’optimisation.",
  link: "/articles/loi-finances-2026-mesures-fiscales",
  date: "Octobre 2025",
  highlight: "Préparez-vous avec notre webinaire exclusif"
};

export default article;
